/**
 * External dependencies
 */
import { createSelector } from 'reselect';
import { get, find, map, sortBy, reverse } from 'lodash';

/**
 * Internal dependencies
 */
import { getAllCoupons } from 'state/coupons/selectors';
import { getAllAddons } from 'state/addons/selectors';

export const getCurrentCloudBackupId = (state) => get(state, ['currentCloudBackup', 'items']);

export const getCurrentCloudBackup = (state) => {
    return get(state, ['currentCloudBackup', 'items'], []);
};

export const requestingCurrentCloudBackup = (state) => get(state, ['currentCloudBackup', 'requesting'], false);

export const errorRequestingCurrentCloudBackup = (state) => get(state, ['currentCloudBackup', 'error'], false);

export const hasScheduledChanges = createSelector(
    getCurrentCloudBackup,
    (currentCloudBackup) => {
        return get(currentCloudBackup, ['has_scheduled_changes'], false);
    },
);
export const getCurrentCloudBackupPlanId = createSelector(
    getCurrentCloudBackup,
    (currentCloudBackup) => {
        return get(currentCloudBackup, ['plan_id'], null);
    },
);